// Namespaced event `type` so it demuxes cleanly on the shared socket. Must match
// the `type` the backend sets on the message.
export const DocumentsDetectedEvent = 'documentHub.documentsDetected';

export interface IDocumentsDetectedMessageDataModel {
  documentIds: number[];
  companyId?: number;
}
